import { Team } from "../../types";

export const playInsGroup1: Team[] = [
  {
    name: "FNC",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819669150_fnc-2021-worlds.png",
    seed: 1,
    region: "lec",
  },
  {
    name: "BYG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1644501610149_BYG_White.png",
    seed: 2,
    region: "pcs",
  },
  {
    name: "DFM",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631820630246_dfm-2021-worlds.png",
    seed: 3,
    region: "ljl",
  },
  {
    name: "EG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1592590374862_EvilGeniusesEG-01-FullonDark.png",
    seed: 4,
    region: "lcs",
  },
  {
    name: "LOUD",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2FLogo-LOUD-Esports_Original.png",
    seed: 5,
    region: "cblol",
  },
  {
    name: "CHF",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1642465931119_ChiefsLogo1000x1000.png",
    seed: 6,
    region: "lco",
  },
];

export const playInsGroup2: Team[] = [
  {
    name: "DRX",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1592589284897_DRXDRX-01-FullonDark.png",
    seed: 1,
    region: "lck",
  },
  {
    name: "RNG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819360134_rng-2021-worlds.png",
    seed: 2,
    region: "lpl",
  },
  {
    name: "SGB",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1636524131703_900px-Saigon_Buffalo.png",
    seed: 3,
    region: "vcs",
  },
  {
    name: "MAD",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819614211_mad-2021-worlds.png",
    seed: 4,
    region: "lec",
  },
  {
    name: "IW",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1654773501062_DenizBankIstanbulWildcatsWhite1.png",
    seed: 5,
    region: "tcl",
  },
  {
    name: "ISG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2FISG.png",
    seed: 6,
    region: "lla",
  },
];

export const groupATeams: Team[] = [
  {
    name: "C9",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631820065346_cloud9-2021-worlds.png",
    seed: 1,
    region: "lcs",
  },
  {
    name: "T1",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819523085_t1-2021-worlds.png",
    seed: 2,
    region: "lck",
  },
  {
    name: "EDG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819297476_edg-2021-worlds.png",
    seed: 3,
    region: "lpl",
  },
  {
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fassets.lolesports.com%2Fwatch%2Fteam-tbd.png",
    name: "TBD",
    seed: 4,
  },
];

export const groupBTeams: Team[] = [
  {
    name: "JDG",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1627457924722_29.png",
    seed: 1,
    region: "lpl",
  },
  {
    name: "G2",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2FG2-FullonDark.png",
    seed: 2,
    region: "lec",
  },
  {
    name: "DK",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819456274_dwg-kia-2021-worlds.png",
    seed: 3,
    region: "lck",
  },
  {
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fassets.lolesports.com%2Fwatch%2Fteam-tbd.png",
    name: "TBD",
    seed: 4,
  },
];

export const groupCTeams: Team[] = [
  {
    name: "RGE",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819715136_rge-2021-worlds.png",
    seed: 1,
    region: "lec",
  },
  {
    name: "TES",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1592592064571_TopEsportsTES-01-FullonDark.png",
    seed: 2,
    region: "lpl",
  },
  {
    name: "GAM",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1643263093448_GAMyellow.png",
    seed: 3,
    region: "vcs",
  },
  {
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fassets.lolesports.com%2Fwatch%2Fteam-tbd.png",
    name: "TBD",
    seed: 4,
  },
];

export const groupDTeams: Team[] = [
  {
    name: "GEN",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1655210113163_GenG_logo_200407-05.png",
    seed: 1,
    region: "lck",
  },
  {
    name: "CFO",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1656307849320_CFO_Logo.png",
    seed: 2,
    region: "pcs",
  },
  {
    name: "100T",
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fstatic.lolesports.com%2Fteams%2F1631819887423_100t-2021-worlds.png",
    seed: 3,
    region: "lcs",
  },
  {
    icon: "https://am-a.akamaihd.net/image?resize=60:60&f=http%3A%2F%2Fassets.lolesports.com%2Fwatch%2Fteam-tbd.png",
    name: "TBD",
    seed: 4,
  },
];
